<template>
  <div class="main_Container">
    <section>
      <div class="container-fluid">
        <div class="section__top">
          <h2 class="section__title">التصنيفات</h2>
          <div class="section__buttons">
            <button
              class="btn add"
              data-bs-toggle="modal"
              data-bs-target="#addCategoryModal"
            >
              <i class="fas fa-plus ms-1"></i>
              إضافة تصنيف جديد
            </button>

            <!-- Start Add Category Modal -->
            <div
              class="modal fade"
              id="addCategoryModal"
              tabindex="-1"
              aria-labelledby="addCategoryModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">أضافة تصنيف</h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      @click="this.clearData()"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <form @submit.prevent="this.addNewCategory($event)">
                      <div class="form-group">
                        <label for="addressTitle">التصنيف</label>
                        <input
                          type="text"
                          class="form-control"
                          id="addressTitle"
                          aria-describedby="addressHelp"
                          v-model="category.title"
                          placeholder="التصنيف"
                          required
                        />
                      </div>

                      <div class="form-group">
                        <label for="addressTitle"> وصف التصنيف</label>
                        <input
                          type="text"
                          class="form-control"
                          id="addressDescription"
                          aria-describedby="addressDescription"
                          v-model="category.description"
                          placeholder="  وصف التصنيف اختياري"
                        />
                      </div>

                      <div class="form-group">
                        <label for="imageCover">صورة التصنيف</label>
                        <input
                          type="file"
                          class="form-control"
                          id="imageCover"
                          placeholder="صورة التصنيف"
                          ref="selectedCategoryImage"
                          @change="onFileSelect($event)"
                          accept="image/*"
                        />
                      </div>

                      <!-- Sub Categories -->
                      <div class="form__head">
                        <span>تصنفات فرعية</span>
                      </div>

                      <div class="subCategory-container">
                        <p class="text-center" v-if="!categoriesForAdd.length">
                          قم بأضافة تصنيف حتى تتمكن من الاختيار
                        </p>
                        <v-select
                          class="form-select form-control mt-2"
                          v-else
                          v-model="this.category.sub_categories"
                          multiple
                          :options="categoriesForAdd"
                          label="title"
                        >
                          <template #option="{ description, title }">
                            {{ title }}
                            <br />
                            <cite class="badge bg-primary"
                              >{{ description }}
                            </cite>
                          </template>
                        </v-select>
                      </div>
                      <br />

                      <div class="row">
                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <label>تصنيف اساسى</label>
                            <div class="radioButtons">
                              <div class="form-check">
                                <label
                                  class="form-check-label"
                                  for="mainCategory1"
                                >
                                  نعم
                                </label>
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="mainCategory"
                                  id="mainCategory1"
                                  :value="true"
                                  v-model="category.main_category"
                                />
                              </div>
                              <div class="form-check me-4">
                                <label
                                  class="form-check-label"
                                  for="mainCategory2"
                                >
                                  لا
                                </label>
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="mainCategory"
                                  id="mainCategory2"
                                  :value="false"
                                  v-model="category.main_category"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <label>الظهور اثناء التسجيل</label>
                            <div class="radioButtons">
                              <div class="form-check">
                                <label
                                  class="form-check-label"
                                  for="userRegister1"
                                >
                                  نعم
                                </label>
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="userRegister"
                                  id="userRegister1"
                                  :value="true"
                                  v-model="category.show_on_register"
                                />
                              </div>
                              <div class="form-check me-4">
                                <label
                                  class="form-check-label"
                                  for="userRegister2"
                                >
                                  لا
                                </label>
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="userRegister"
                                  id="userRegister2"
                                  :value="false"
                                  v-model="category.show_on_register"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Modal Buttons -->
                      <div class="form-group text-start mt-4">
                        <button
                          type="submit"
                          class="btn add w-100"
                          :disabled="this.isloading"
                        >
                          أضافة
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <!-- End Add Category Modal -->

            <div class="dropdown sorting">
              <button
                class="btn add me-2 dropdown-toggle"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                type="button"
              >
                <i class="fas fa-filter ms-1"></i>
                ترتيب التصنيفات
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li class="dropdown-item" @click="sortByCreateDate">
                  ترتيب حسب التاريخ
                </li>
                <li class="dropdown-item" @click="sortByName">
                  ترتيب حسب الاسم
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Data -->
        <div class="data">
          <!-- Loading before data comes -->
          <div v-show="this.isloading" class="data__loading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div v-show="!this.isloading" class="table-responsive">
            <form @submit.prevent="">
              <div class="searching">
                <div class="form-group">
                  <input
                    type="search"
                    @input="getDocBySeacrh"
                    v-model="searchValue"
                    class="form-control mt-2"
                    placeholder="هل تبحث عن ...."
                    required
                  />
                </div>
              </div>
            </form>
            <!-- check data exist -->

            <table
              v-show="this.categories.length > 0"
              class="table table-striped"
            >
              <!-- check data exist -->
              <!-- tabel Head -->
              <thead>
                <tr>
                  <th scope="col">الرقم</th>
                  <th scope="col">الوصف</th>
                  <th scope="col">تصنيف اساسى</th>
                  <th scope="col">الظهور اثناء التسجيل</th>
                  <th scope="col">التصنيفات الفرعية</th>
                  <th scope="col">التحكم</th>
                </tr>
              </thead>

              <!-- tabel body -->
              <tbody>
                <tr v-for="(category, index) in this.categories" :key="index">
                  <th scope="row">
                    {{ index + 1 }}
                  </th>

                  <td>
                    <span>{{ category.title }}</span>
                    <span
                      class="badge bg-warning"
                      style="color: black"
                      v-show="category.description"
                    >
                      {{ category.description }}</span
                    >
                  </td>
                  <!-- <td>{{ category.description }}</td> -->

                  <td>{{ booleanToYesNo(category.main_category) }}</td>
                  <td>{{ booleanToYesNo(category.show_on_register) }}</td>

                  <td>
                    <span v-if="!category.sub_categories.length"
                      >لا يوجد تصنيفات فرعية</span
                    >

                    <ol v-else>
                      <li
                        :key="subCate.category_id"
                        v-for="subCate in category.sub_categories"
                      >
                        {{ subCate.title }}
                      </li>
                    </ol>
                  </td>
                  <td class="controls">
                    <!-- View Button -->
                    <button
                      class="btn view"
                      data-bs-toggle="modal"
                      data-bs-target="#selectedCategory"
                      @click="viewCategory(category)"
                    >
                      <i class="fas fa-folder ms-1"></i>
                      عرض
                    </button>

                    <!-- Start View Category Modal -->
                    <div
                      class="modal fade"
                      id="selectedCategory"
                      tabindex="-1"
                      aria-labelledby="selectedCategoryLabel"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="selectedCategoryLabel">
                              تفاصيل التصنيف
                            </h5>
                            <button
                              type="button"
                              class="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div class="modal-body">
                            <div class="category__details">
                              <span>أسم التصنيف: </span>
                              <span>{{ selectedCategory.title }}</span>
                            </div>
                            <div class="category__details">
                              <span>وقت الانشاء: </span>
                              <span>{{ selectedCategory.created_date }}</span>
                            </div>
                            <div class="category__details">
                              <span>صورة التصنيف: </span>
                              <span class="mt-2" v-if="selectedCategory.image">
                                <img
                                  :src="selectedCategory.image"
                                  alt="صورة التصنيف"
                                  class="w-100"
                                />
                              </span>
                              <span v-else>لا يوجد</span>
                            </div>
                            <div class="category__details">
                              <span>الظهور اثناء التسجيل: </span>
                              <span>{{
                                booleanToYesNo(
                                  selectedCategory.show_on_register
                                )
                              }}</span>
                            </div>
                            <div class="category__details">
                              <span>تصنيف اساسى: </span>
                              <span>{{
                                booleanToYesNo(selectedCategory.main_category)
                              }}</span>
                            </div>
                            <div class="category__details">
                              <span>التصنيفات الفرعية: </span>
                              <span
                                v-if="!selectedCategory.sub_categories?.length"
                                >لا يوجد تصنيفات فرعية
                              </span>
                              <ol v-else class="me-4">
                                <li
                                  :key="sub.category_id"
                                  v-for="sub in selectedCategory.sub_categories"
                                >
                                  {{ sub.title }}
                                </li>
                              </ol>
                            </div>
                          </div>

                          <div class="modal-footer">
                            <button
                              type="button"
                              class="btn delete"
                              data-bs-dismiss="modal"
                            >
                              إلغاء
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End View Category Modal -->

                    <!-- Update Button -->
                    <button
                      class="btn me-2 edit"
                      data-bs-toggle="modal"
                      data-bs-target="#updateCategoryModal"
                      @click="this.getCategory(category)"
                    >
                      <i class="fas fa-edit ms-2"></i>
                      تعديل
                    </button>

                    <!-- Start Update Category Modal -->
                    <div
                      class="modal fade"
                      id="updateCategoryModal"
                      tabindex="-1"
                      aria-labelledby="updateCategoryModalLabel"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5
                              class="modal-title"
                              id="updateCategoryModalLabel"
                            >
                              تعديل التصنيف
                            </h5>
                            <button
                              type="button"
                              class="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                              @click="this.clearData()"
                            ></button>
                          </div>
                          <div class="modal-body">
                            <form
                              @submit.prevent="
                                this.updateSelectedCategory($event)
                              "
                            >
                              <div class="form-group">
                                <label for="categoryTitle">أسم التصنيف</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="categoryTitle"
                                  v-model="updateCategoryData.title"
                                />
                              </div>

                              <div class="form-group">
                                <label for="categoryDescription">الوصف</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  id="categoryDescription"
                                  v-model="updateCategoryData.description"
                                />
                              </div>

                              <div class="row">
                                <div class="col-6">
                                  <div class="form-group">
                                    <label for="imageCover">صورة التصنيف</label>
                                    <input
                                      type="file"
                                      class="form-control"
                                      id="imageCover"
                                      placeholder="صورة التصنيف"
                                      ref="selectedCategoryImage"
                                      @change="onFileSelect($event)"
                                      accept="image/*"
                                    />
                                  </div>
                                </div>
                                <!-- Image -->
                                <div
                                  class="col-6"
                                  v-if="this.updateCategoryData.image"
                                >
                                  <img
                                    :src="this.updateCategoryData.image"
                                    alt="صورة التصنيف"
                                    class="w-100"
                                  />
                                </div>
                                <div class="col-6" v-else>
                                  <span>لا يوجد</span>
                                </div>
                              </div>

                              <!-- Sub Categories -->
                              <div class="form__head">
                                <span>تصنفات فرعية</span>
                              </div>
                              <div class="subCategory-container">
                                <p
                                  class="text-center"
                                  v-if="!categoriesForAdd.length"
                                >
                                  قم بأضافة تصنيف حتى تتمكن من الاختيار
                                </p>

                                <v-select
                                  class="form-select form-control mt-2"
                                  v-else
                                  v-model="
                                    this.updateCategoryData.sub_categories
                                  "
                                  multiple
                                  :options="categoriesForAdd"
                                  label="title"
                                >
                                  <template #option="{ description, title }">
                                    {{ title }}
                                    <br />
                                    <cite class="badge bg-primary"
                                      >{{ description }}
                                    </cite>
                                  </template>
                                </v-select>
                              </div>

                              <br />

                              <div class="row mt-2">
                                <div class="col-md-6 col-12">
                                  <div class="form-group">
                                    <label>تصنيف اساسى</label>
                                    <div class="radioButtons">
                                      <div class="form-check">
                                        <label
                                          class="form-check-label"
                                          for="mainCategory1"
                                        >
                                          نعم
                                        </label>
                                        <input
                                          class="form-check-input"
                                          type="radio"
                                          name="mainCategory"
                                          id="mainCategory1"
                                          :value="true"
                                          v-model="
                                            updateCategoryData.main_category
                                          "
                                        />
                                      </div>
                                      <div class="form-check me-4">
                                        <label
                                          class="form-check-label"
                                          for="mainCategory2"
                                        >
                                          لا
                                        </label>
                                        <input
                                          class="form-check-input"
                                          type="radio"
                                          name="mainCategory"
                                          id="mainCategory2"
                                          :value="false"
                                          v-model="
                                            updateCategoryData.main_category
                                          "
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6 col-12">
                                  <div class="form-group">
                                    <label>الظهور اثناء التسجيل</label>
                                    <div class="radioButtons">
                                      <div class="form-check">
                                        <label
                                          class="form-check-label"
                                          for="userRegister1"
                                        >
                                          نعم
                                        </label>
                                        <input
                                          class="form-check-input"
                                          type="radio"
                                          name="userRegister"
                                          id="userRegister1"
                                          :value="true"
                                          v-model="
                                            updateCategoryData.show_on_register
                                          "
                                        />
                                      </div>
                                      <div class="form-check me-4">
                                        <label
                                          class="form-check-label"
                                          for="userRegister2"
                                        >
                                          لا
                                        </label>
                                        <input
                                          class="form-check-input"
                                          type="radio"
                                          name="userRegister"
                                          id="userRegister2"
                                          :value="false"
                                          v-model="
                                            updateCategoryData.show_on_register
                                          "
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Modal Buttons -->
                              <div class="form-group text-start mt-4">
                                <button type="submit" class="btn add w-100">
                                  تعديل
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Start Update Category Modal -->

                    <!-- Delete Button -->
                    <button
                      class="btn me-2 delete"
                      @click="this.deleteSelectedCategory(category)"
                    >
                      <i class="fas fa-trash-alt ms-2"></i>
                      حذف
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- check data empty -->
            <div
              v-show="
                (!this.isloading && !this.categories) ||
                this.categories.length == 0
              "
              class="empty-state"
            >
              <div class="empty-state__icon">
                <i class="fas fa-folder"></i>
              </div>
              <h3 class="empty-state__text">لا يوجد تصنيفات حتى الآن</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Swal
import Swal from "sweetalert2";
// Vuex
import { mapActions, mapGetters } from "vuex";
// Firebase Upload Component
import FirebaseUploadingFileVue from "@/components/FirebaseUploadingFile.vue";
// Toast to Show Message
import { useToast, TYPE } from "vue-toastification";
// Delete from firebase Storage
import { deleteFileFromUrl } from "@/firebase/firebase_storage";

const toast = useToast();

export default {
  data() {
    return {
      updateCategoryData: {},
      uploadProgress: 0,
      file: null,
      isloading: true,
      categories: [],
      categoriesForAdd: [],
      category: {
        category_id: "",
        title: "",
        description: "",
        image: "",
        show_on_register: false,
        main_category: false,
        sub_categories: [],
      },
      subCategory: null,
      selectedCategory: {},
      // Search
      searchValue: "",
    };
  },
  components: {},
  methods: {
    // Vuex
    ...mapActions("categoriesModule", [
      "fetchCategories",
      "addCategory",
      "updateCategory",
      "getCategoryByID",
      "deleteCategory",
    ]),

    //-----------------------------------------------
    // Sort
    sortByCreateDate() {
      this.categories.sort(
        (a, b) => b.created_date.seconds - a.created_date.seconds
      );
    },
    sortByName() {
      this.categories.sort((a, b) => (a.title < b.title ? -1 : 1));
    },
    //-----------------------------------------------
    // Search
    getDocBySeacrh() {
      setTimeout(() => {
        var re = new RegExp(this.searchValue + ".+$", "i");
        this.categories = this.getCategories.filter(
          (item) => item.title.search(re) != -1
        );
      }, 800);
    },
    //-----------------------------------------------

    /***********************************/
    /******  Main Button To Add  *******/
    /***********************************/
    // Create New category
    async addNewCategory(event) {
      let file = this.file;
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");

      if (file !== null) {
        const content = {
          // Your component or JSX template
          component: FirebaseUploadingFileVue,

          // Props are just regular props, but these won't be reactive
          props: {
            title: "يتم رفع التصنيف الان",
            file: file,
            collection: "IMAGEs",
            onFinished: (url) => {
              this.category.image = url ?? "";
              toast.dismiss(toastId);
              this.addCategory(this.category);
              closeButton.click();
              this.clearAndShowSuccess();
            },
          },
        };

        const toastId = toast(content, {
          icon: false,
          hideProgressBar: true,
          closeButton: false,
          type: TYPE.INFO,
          timeout: false,
          toastClassName: "my-custom-toast-class",
        });
      } else {
        await this.addCategory(this.category);
        closeButton.click();
        this.clearAndShowSuccess();
      }
    },
    //-----------------------------------------//
    /***********************************/
    /****** Buttons In Every Row *******/
    /***********************************/
    // 1- View Category
    viewCategory(category) {
      this.selectedCategory = category;
    },
    // 2- Get Category By ID And Show Update Modal
    async getCategory(category) {
      this.updateCategoryData = await this.getCategoryByID(
        category.category_id
      );
    },
    // 2- Update Category
    async updateSelectedCategory(event) {
      let file = this.file;
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");

      if (file !== null) {
        const content = {
          // Your component or JSX template
          component: FirebaseUploadingFileVue,

          // Props are just regular props, but these won't be reactive
          props: {
            title: "يتم رفع التصنيف الان",
            file: file,
            collection: "IMAGEs",
            onFinished: (url) => {
              this.updateCategoryData.image = url ?? "";
              toast.dismiss(toastId);
              this.updateCategory(this.updateCategoryData);
              closeButton.click();
              this.clearAndShowSuccess();
            },
          },
        };

        const toastId = toast(content, {
          icon: false,
          hideProgressBar: true,
          closeButton: false,
          type: TYPE.INFO,
          timeout: false,
        });
      } else {
        await this.updateCategory(this.updateCategoryData);
        closeButton.click();
        this.clearAndShowSuccess();
      }
    },

    // 3- Delete Category
    async deleteSelectedCategory(category) {
      Swal.fire({
        text: "هل أنت متأكد من حذف هذا التصنيف؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم حذف التصنيف بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.deleteCategory(category.category_id);
          deleteFileFromUrl(category.image);
        }
      });
    },
    //-----------------------------------------//
    onFileSelect(e) {
      var file = e.target.files[0] || e.dataTransfer;
      document.getElementById("imageCover").innerHTML = file.name;
      this.file = file;
    },

    // Convert a Boolean value to Yes/No
    booleanToYesNo(value) {
      return value ? "نعم" : "لا";
    },

    clearAndShowSuccess() {
      this.seccussAddCate();
      this.clearData();
    },
    seccussAddCate() {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: "تم إضافة التصنيف بنجاح",
      });
    },
    // clear Data when close modal
    clearData() {
      this.file = null;
      this.category = {
        title: "",
        image: "",
        description: "",
        show_on_register: false,
        main_category: false,
        sub_categories: [],
      };
    },
  },

  async created() {},

  computed: {
    ...mapGetters("categoriesModule", [
      "getCategories",
      "isLoading",
      "getLesson",
    ]),
  },

  watch: {
    getCategories() {
      this.categories = this.getCategories;
      this.categoriesForAdd = this.getCategories;
    },

    isLoading() {
      this.isloading = this.isLoading;
    },
  },
  mounted() {
    this.categories = this.getCategories;
    this.categoriesForAdd = this.getCategories;
    this.isloading = this.isLoading;
  },
};
</script>


